import { useSyncExternalStore } from 'react';
import { sphereIndicatorsStore, type SphereIndicatorsState } from './sphereIndicatorsStore';

const IDLE: SphereIndicatorsState = { status: 'idle' };

/** Subscribes to one sphere's indicators; an unsaved sphere (no id) stays idle. */
export function useSphereIndicators(sphereId: string | undefined): SphereIndicatorsState {
  return useSyncExternalStore(
    sphereIndicatorsStore.subscribe,
    () => (sphereId ? sphereIndicatorsStore.peek(sphereId) : IDLE),
    () => IDLE,
  );
}
